import { colors } from '../utils/colors';
import { layoutTokens } from './layoutTokens';
import { ThemePalette } from './types';
import { getEasterPaletteOverrides } from './easterTheme';

const easterPaletteOverrides = getEasterPaletteOverrides(true);

export const bluePalette: ThemePalette = {
    // Semantic tokens (no isDarkTheme conditionals in components)
    listItemHoverBackground: 'rgba(255, 255, 255, 0.08)',
    modalListBackground: 'rgba(2, 6, 23, 0.72)',
    modalContentText: colors.white.basic,
    importErrorRowBackground: 'rgba(255, 120, 120, 0.14)',
    stickyHeaderIconColor: 'rgba(0, 0, 0, 0.6)',
    // DataGrid (dark theme)
    dataGridHeaderTitleColor: 'rgba(255, 255, 255, 0.92)',
    dataGridPaginationText: 'rgba(255, 255, 255, 0.82)',
    dataGridFooterBackground: 'rgba(255, 255, 255, 0.06)',
    dataGridRowBorderColor: 'rgba(255, 255, 255, 0.14)',
    dataGridCellBorderColor: 'rgba(255, 255, 255, 0.12)',
    dataGridColumnSeparatorColor: 'rgba(255, 255, 255, 0.24)',
    dataGridScrollbarTrack: 'rgba(255, 255, 255, 0.08)',
    dataGridScrollbarThumb: 'rgba(255, 255, 255, 0.2)',
    dataGridScrollbarThumbBorder: 'rgba(255, 255, 255, 0.08)',
    dropdownMenuPaperBg: 'rgba(15, 23, 42, 0.74)',
    dropdownMenuItemSelectedBg: 'rgba(255, 255, 255, 0.14)',
    dropdownMenuItemSelectedHoverBg: 'rgba(255, 255, 255, 0.2)',
    activeSpeakerBarBackground: 'rgba(229, 233, 242, 0.9)',
    cardWatermarkColor: 'rgba(181, 187, 237, 0.102)',
    userStatusActiveBg: 'rgba(47, 184, 137, 0.18)',
    userStatusActiveText: '#8EF0C7',
    userStatusInactiveBg: 'rgba(251, 191, 36, 0.16)',
    userStatusInactiveText: '#F9D66B',
    evaluationViewBasicContainerBg: 'rgba(255, 255, 255, 0.08)',
    evaluationViewBasicContainerBorder: 'rgba(255, 255, 255, 0.14)',
    evaluationViewDialogDividerBorder: 'rgba(255, 255, 255, 0.18)',
    evaluationViewRatingContainerBg: 'rgba(255, 255, 255, 0.08)',
    filterBorderColor: 'rgba(255,255,255,0.24)',

    surfaceOverlay: 'rgba(255, 255, 255, 0.1)',
    surfaceOverlayHover: 'rgba(255, 255, 255, 0.08)',
    surfaceBorderSubtle: 'rgba(255,255,255,0.24)',
    disabledControlBorder: 'rgba(255, 255, 255, 0.52)',
    disabledControlBg: 'rgba(255, 255, 255, 0.06)',
    buttonAccentText: '#0f172a',
    buttonAccentOutlinedText: '#0f172a',
    buttonAccentBg: '#fbbf24',
    buttonAccentHoverBg: '#f59e0b',
    buttonAccentSoftBg: 'rgba(251, 191, 36, 0.14)',
    buttonAccentSoftHoverBg: 'rgba(251, 191, 36, 0.22)',
    buttonAccentSoftActiveBg: 'rgba(251, 191, 36, 0.12)',
    buttonAccentSoftDisabledBg: 'rgba(251, 191, 36, 0.08)',
    buttonAccentDisabledText: 'rgba(45, 34, 0, 0.7)',
    buttonAccentDisabledBg: 'rgba(251, 191, 36, 0.45)',
    buttonAccentDisabledBorder: 'rgba(251, 191, 36, 0.45)',
    headerFlagGermanStripeBlack: colors.black.default,
    headerFlagGermanStripeRed: colors.red.monza,
    headerFlagGermanStripeGold: '#FFCE00',
    headerFlagEuBackground: '#003399',
    headerFlagEuStars: '#FFCE00',
    headerBadgeText: colors.white.basic,

    // Common
    pageBackground: '#020617',
    modalBackdropBg: 'rgba(2, 6, 23, 0.72)',
    layoutBackground: 'linear-gradient(180deg, #2563EB 0%, #020617 100%)',
    layoutPatternGradient: 'radial-gradient(circle, rgba(255, 255, 255, 0.08) 1.2px, transparent 1.2px)',
    layoutIconsPatternFillColor: 'rgba(166,190,255,0.08)',
    contentLinkColor: '#fbbf24',
    contentPaperBackground: 'rgba(255, 255, 255, 0.1)',
    contentPaperBorder: 'rgba(255,255,255,0.2)',
    contentPaperText: colors.white.basic,
    pageNavIconColor: 'rgba(255,255,255,0.7)',
    contentTableBackground: 'rgba(255, 255, 255, 0.08)',
    contentTableBorder: 'rgba(255,255,255,0.16)',
    contentActionIconColor: '#fbbf24',
    accordionBackground: 'rgba(255, 255, 255, 0.1)',
    accordionBorderColor: 'rgba(255, 255, 255, 0.16)',
    accordionTextColor: colors.white.basic,
    accordionExpandIconColor: 'rgba(255,255,255,0.7)',
    tableActionButtonColor: '#fbbf24',
    tableActionButtonBg: '#fbbf24',
    contentSectionIconColor: 'rgba(255,255,255,0.7)',
    contentListBackground: 'transparent',
    qualityManagementScoreChipBg: '#239d79',
    qualityManagementScoreChipText: '#ffffff',
    qualityManagementTopActionOutlinedColor: '#fbbf24',
    qualityManagementTopActionOutlinedBorder: '#fbbf24',
    qualityManagementTopActionOutlinedBg: 'rgba(251, 191, 36, 0.14)',
    qualityManagementTopActionOutlinedHoverBg: 'rgba(251, 191, 36, 0.22)',
    qualityManagementTopActionContainedBg: '#fbbf24',
    qualityManagementTopActionContainedText: '#0f172a',
    qualityManagementTopActionOutlinedDisabledText: 'rgba(251, 191, 36, 0.55)',
    qualityManagementTopActionDisabledBorder: 'rgba(251, 191, 36, 0.45)',
    qualityManagementTopActionSoftDisabledBg: 'rgba(251, 191, 36, 0.08)',
    qualityManagementTopActionContainedDisabledText: 'rgba(15, 23, 42, 0.7)',
    qualityManagementTopActionContainedDisabledBg: 'rgba(251, 191, 36, 0.45)',
    qualityManagementTopActionContainedHoverBg: '#f59e0b',
    contentChartGridStroke: 'rgba(255, 255, 255, 0.16)',
    contentChartAxisStroke: 'rgba(255, 255, 255, 0.22)',
    contentChartTickFill: 'rgba(255, 255, 255, 0.86)',
    contentChartLineStroke: '#fbbf24',
    contentChartTooltipBg: 'rgba(15, 23, 42, 0.94)',
    contentChartTooltipBorder: 'rgba(255, 255, 255, 0.2)',
    contentChartTooltipText: colors.white.basic,
    headerTabTextColor: colors.white.basic,
    selectedTabTextColor: colors.white.basic,
    headerTabIndicatorColor: colors.white.basic,
    // Oceanic dark theme background from reference NEW_UI HTML.
    headerBackground: 'linear-gradient(180deg, #2563EB 0%, #020617 100%)',

    headerLogoColor: colors.white.basic,
    headerControlHoverBackground: easterPaletteOverrides.headerControlHoverBackground || 'rgba(255, 255, 255, 0.16)',

    titleText: colors.white.basic,
    borderShadowColor: 'rgba(0,0,0,0.32)',
    mainActionButtonBg: colors.blue.i2x,
    mainActionButtonHighAlertBg: '#b00020',
    mainActionButtonTextColor: colors.white.basic,
    secondaryActionButtonTextColor: colors.blue.perano,
    secondaryDeleteButtonTextColor: colors.red.cupid,
    borderColor: 'rgba(255,255,255,0.2)',
    betaTagColor: 'rgba(255,255,255,0.7)',
    inputLabelColor: 'rgba(255,255,255,0.6)',
    secondaryTextColor: 'rgba(255,255,255,0.6)',
    qualityIndexYellow: '#f2b24f',

    // Filters
    buttonColor: '#fbbf24',
    buttonColorOnHover: '#f59e0b',
    isDarkTheme: true,
    filterPopupBorder: 'rgba(255, 255, 255, 0.22)',
    whatsNewButtonActiveBg: '#fbbf24',
    whatsNewButtonActiveText: '#0f172a',
    whatsNewButtonInactiveBg: 'transparent',
    whatsNewButtonInactiveText: colors.white.basic,
    whatsNewButtonInactiveBorder: colors.white.basic,
    modalFooterDisabledText: colors.blue.rock_blue,
    modalTitleText: colors.white.basic,
    modalSubtitleBackground: 'rgba(255, 255, 255, 0.1)',
    autocompleteModalChip: colors.blue.after_work_blue,
    modalSubtext: colors.blue.cadet,
    modalTitle: colors.white.basic,
    modalCheckbox: colors.blue.rock_blue,
    modalFooterPrimaryButtonBg: '#fbbf24',
    modalFooterPrimaryButtonText: '#0f172a',
    modalFooterPrimaryButtonHoverBg: '#f59e0b',
    modalFooterPrimaryButtonDisabledBg: 'rgba(251, 191, 36, 0.45)',
    modalFooterPrimaryButtonDisabledText: 'rgba(15, 23, 42, 0.6)',
    modalFooterSecondaryButtonDisabledText: 'rgba(15, 23, 42, 0.6)',
    dateRangeLabelHighlighted: '#fbbf24',
    dateRangeText: colors.white.basic,
    dateRangeSelectedDateText: colors.white.basic,
    contentDatePresetButtonHoverBg: 'rgba(255, 255, 255, 0.08)',
    contentDatePresetDisabledText: 'rgba(255, 255, 255, 0.72)',
    contentFilterInputBackground: 'rgba(0, 0, 0, 0.2)',
    contentFilterInputBorderRadius: layoutTokens.filterInputBorderRadius,
    contentFilterInputPadding: layoutTokens.filterInputPadding,
    contentFilterInputUnderlineBefore: 'rgba(255,255,255,0.38)',
    contentFilterInputUnderlineHover: colors.white.basic,
    contentFilterInputUnderlineAfter: '#fbbf24',
    contentCalendarAccentBg: 'rgba(251, 191, 36, 0.28)',
    contentCalendarActionColor: '#fbbf24',
    rangePickerMain: '#fbbf24',
    rangePickerBorderBottom: 'rgba(255,255,255,0.42)',
    rangePickerFooterBorder: colors.blue.after_work_blue,
    timePickerColor: 'rgba(255,255,255,0.7)',
    removeButtonColor: 'rgba(255,255,255,0.6)',
    downArrowColor: 'rgba(255,255,255,0.7)',

    // Dashboard
    speechRatioProgressBarRight: colors.blue.after_work_blue,
    callsCountSubtext: colors.blue.rock_blue,
    tableProgressCellDefault: colors.blue.i2x,
    tableLabelText: colors.white.basic,
    cardFooterBorder: 'rgba(100, 130, 200, 0.4)',
    cardInfoHeaderPopupContent: colors.blue.rock_blue,
    cardTooltipBackground: 'rgba(15, 23, 42, 0.74)',
    dashboardCardBackground: 'rgba(255, 255, 255, 0.1)',
    dashboardHeaderBackground: 'transparent',
    dashboardHeaderTabTextColor: 'rgba(255, 255, 255, 0.88)',
    dashboardHeaderTabSelectedTextColor: '#ffffff',
    dashboardHeaderTabIndicatorColor: '#ffffff',
    dashboardHeaderDateRangeTextColor: 'rgba(255, 255, 255, 0.9)',
    dashboardHeaderDateRangeBorderColor: 'rgba(255, 255, 255, 0.38)',
    dashboardHeaderDateRangeHighlightColor: '#fbbf24',
    dashboardHeaderDateRangeSelectedTextColor: '#0f172a',
    dashboardCardAccentColor: '#fbbf24',
    dashboardCardSortIconColor: 'rgba(255,255,255,0.7)',
    cardActionButtonText: colors.white.basic,
    cardActionButtonIcon: '#fbbf24',
    dashboardSentimentPositive: '#35c391',
    dashboardSentimentNeutral: colors.blue.perano,
    dashboardSentimentNegative: colors.yellow.golden_tainoi,

    // Reports
    reportsCellBorder: 'rgba(178, 206, 255, 0.38)',
    reportsCellBackground: 'rgba(114, 153, 243, 0.26)',
    reportsKeywordUseCellBorder: 'rgba(178, 206, 255, 0.32)',
    reportsKeywordSetGroupBackground: 'rgba(82, 114, 239, 0.42)',
    reportsHeadCellText: colors.white.basic,
    reportsText: colors.white.basic,
    reportsSubText: colors.blue.rock_blue,

    // Reports v2

    // Call History
    callDetailsSubHeading: colors.blue.rock_blue,
    callHistoryDoSay: '#2fb889',
    callHistoryDoSayComplement: colors.yellow.neon_carrot,
    callHistoryPlayerFilled: colors.blue.cadet,
    callHistoryProgressBarBackground: colors.blue.after_work_blue,
    callHistorySpeedBorder: colors.blue.rock_blue,
    callHistorySpeedSelected: colors.blue.i2x,
    callHistoryAgentSpeaker: colors.blue.fresh_air,
    callHistorySentimentPositive: '#31bc8d',
    callHistorySentimentNegative: colors.red.fiery_rose,
    callHistorySentimentNeutral: colors.blue.rock_blue,
    callHistoryCustomerSpeaker: colors.blue.lavender_blue_shadow,
    callHistorySpeakerBarBackground: colors.blue.after_work_blue,
    callHistorySearchHighlight: colors.yellow.neon_carrot,
    callHistorySearchFaded: colors.yellow.glossy_gold,
    callHistoryTranscriptSearchBackground: '#5d7dc6',
    callHistoryTranscriptSearchFocus: 'rgba(255,255,255,0.6)',
    callHistorySearchBoxTitleBorder: colors.blue.after_work_blue,
    callHistorySearchDoSayProgressBarBackground: colors.blue.after_work_blue,
    callHistoryText: colors.white.basic,
    callHistoryDontSay: colors.red.light_carmine_pink,
    callHistoryBoxShadow: 'rgba(0, 0, 0, 0.4)',
    callHistoryDisabledWordColor: 'rgba(255,255,255,0.34)',
    callHistoryCurrentWord: colors.blue.perano,
    callHistoryAppliedFilterBackground: 'rgba(82, 114, 239, 0.2)',
    callHistoryTableScoreCardLabelText: colors.white.basic,
    callHistoryTableCallTopicsText: colors.blue.perano,
    callHistoryTableCallTopicsBorder: colors.blue.i2x,
    callHistoryTableCallTopicsBackground: 'rgb(6, 39, 97)',
    callHistoryTableCallTopicsActiveBackground: 'rgb(28, 64, 128)',
    callHistoryTableCallTopicsSeparator: 'rgba(82, 114, 239, 0.3)',
    callHistoryTableNoTopicBackground: colors.blue.after_work_blue,
    callHistoryUtteranceHighlightActive: 'rgba(255, 206, 0, 0.35)',
    callHistoryUtteranceHighlightGroup: 'rgba(255, 206, 0, 0.25)',
    callHistoryFlexibleGroupBackground: 'rgba(47, 184, 137, 0.2)',
    callHistoryFlexibleGroupActiveBackground: 'rgba(47, 184, 137, 0.36)',
    callHistoryFlexibleDontSayBackground: 'rgba(255, 80, 110, 0.2)',
    callHistoryFlexibleDontSayActiveBackground: 'rgba(255, 80, 110, 0.36)',
    callHistoryUtteranceAnimationFrom: 'rgba(255, 206, 0, 0.2)',
    callHistoryUtteranceHighlightDefault: colors.blue.bay_of_many,
    callHistoryWordText: colors.white.basic,
    callHistoryWordCurrent: 'rgba(255,255,255,0.87)',
    callHistoryTooltipText: colors.white.basic,
    callDetailsLoaderForeground: 'rgba(255,255,255,0.2)',
    callDetailsLoaderBackground: 'rgba(255,255,255,0.08)',

    // Key Word Manager
    keyWordMangerRowBackground: 'rgba(255, 255, 255, 0.08)',
    keyWordMangerRowDragIcon: colors.blue.rock_blue,
    keyWordMangerRowBackgroundEditMode: 'rgba(255, 255, 255, 0.14)',
    keyWordMangerRowBackgroundBorder: 'rgba(255,255,255,0.18)',
    keyWordMangerConfirmButtonWrapperEnabled: 'rgba(251, 191, 36, 0.18)',
    keyWordMangerConfirmButtonActiveColor: colors.white.basic,
    keyWordMangerTagInput: colors.blue.rock_blue,
    keyWordMangerTagBorder: colors.white.basic,
    keyWordMangerInvalidTagTooltipBg: colors.red.light_carmine_pink,
    keyWordMangerPopupMsgBg: 'rgba(11, 20, 42, 0.92)',
    keyWordMangerPopupMsgColor: colors.white.basic,
    keyWordMangerPopupShadow: 'rgba(0, 0, 0, 0.34)',
    keyWordMangerStarColor: colors.yellow.star,
    keyWordMangerPhoneIconColor: colors.yellow.star,
    keyWordMangerHeaderBorderBottom: 'rgba(255,255,255,0.18)',
    keyWordMangerListHeaderBg: 'rgba(255, 255, 255, 0.08)',
    keyWordMangerListHeaderText: 'rgba(255,255,255,0.86)',
    keyWordMangerDontSay: colors.red.monza,
    keyWordMangerDoSay: '#2fb889',
    keyWordMangerWarning: colors.yellow.neon_carrot
};
